import { useRef, useState } from 'react';
import YouTube, { YouTubeProps, YouTubeEvent } from 'react-youtube';
import YouTubeVideoId from 'youtube-video-id';
import { videoStartEvent } from 'analytics/events/studio';
import { StudioBaseImageV2 } from 'shared/studio/StudioBaseImage/StudioBaseImage';
import { FullEduHubArticleResult } from 'types/studio/eduHub';
import { YouTubeIcon } from '@ag1/ui';
import styles from './EduArticleHeroYoutubeVideo.module.scss';

interface Props {
  heroVideo: FullEduHubArticleResult['heroVideo'];
  mobile?: boolean;
}

export const EduArticleHeroYoutubeVideo = ({ heroVideo, mobile = false }: Props) => {
  const playerRef = useRef<YouTube>(null);
  const [buttonClicked, setButtonClicked] = useState(false);

  if (typeof heroVideo?.url !== 'string') {
    return null;
  }

  const id = heroVideo.url ? YouTubeVideoId(heroVideo.url) : '';

  const onPlayerReady: YouTubeProps['onReady'] = (event) => {
    event.target?.pauseVideo();
  };

  const opts: YouTubeProps['opts'] = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 0,
      rel: 0,
      share: 0,
      color: 'white'
    }
  };

  const handlePlay = () => {
    if (!buttonClicked && playerRef.current && playerRef.current.internalPlayer) {
      playerRef.current.internalPlayer.playVideo();
      setButtonClicked(true);
    }
  };

  const onPlay = (event: YouTubeEvent<number>) => {
    const duration = event.target.getDuration();
    const title = event.target.videoTitle;

    videoStartEvent({
      videoProvider: 'youtube',
      videoTitle: title,
      videoUrl: heroVideo.url,
      videoDuration: duration
    });
  };

  return (
    <div className={mobile ? styles.youtubeContainerMobile : styles.youtubeContainerDesktop}>
      {!buttonClicked && (
        <div className={styles.coverImageOverlay}>
          <StudioBaseImageV2 image={heroVideo.coverImage} className={styles.imageCover} />
          <button type="button" onClick={handlePlay}>
            <YouTubeIcon className={styles.icon} />
          </button>
        </div>
      )}

      <YouTube
        videoId={id}
        opts={opts}
        className={styles.video}
        ref={playerRef}
        onReady={onPlayerReady}
        onPlay={onPlay}
      />
    </div>
  );
};
